<app-notification-bell
  [unreadCount]="notifications.unread()"
  [items]="notifications.items()"
  [open]="notifications.open()"
  [loading]="notifications.loading()"
  [loadError]="notifications.loadError()"
  [showChannelsLink]="canOpenSettings()"
  (toggled)="notifications.toggle()"
  (itemSelected)="notifications.openItem($event)"
  (closed)="notifications.close()"
  (channelsLinkClicked)="openChannelsSettings()"
/>
